class PlatformDetect
    Android: ()->
        "Android" if navigator.userAgent.match(/Android/i)
    BlackBerry: ()->
        "BlackBerry" if navigator.userAgent.match(/BlackBerry/i)
    iOS: ()->
        "iOS" if navigator.userAgent.match(/iPhone|iPad|iPod/i)
    Opera: ()->
        "Opera-Mini" if navigator.userAgent.match(/Opera Mini/i)
    Windows: ()->
        'IEMobile' if navigator.userAgent.match(/IEMobile/i)

    isMobile: ()=>
        @getPlatform() != "Desktop"

    # if no match is made we default to the "desktop" platform.
    getPlatform: ()=>
        (@Android() || @BlackBerry() || @iOS() || @Opera() || @Windows() || "Desktop")

    addPlatformClassesToElement: (el)=>
        platform = @getPlatform()
        el.addClass("platform-#{platform}")
        el

module.exports = PlatformDetect



// WEBPACK FOOTER //
// ./app/lib/PlatformDetect.coffee